import { Button } from '@bfe/moly';
import { PasskeyIcon } from '@bfe/moly-icons';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useI18nContext } from '@/i18n/I18n';
import { getPasskeyList } from '@/services/passkey';

const PassKey = () => {
  const [$t] = useI18nContext();
  const navigate = useNavigate();
  const [hasBindPasskey, setHasBindPasskey] = useState(false);
  const handleClick = () => {
    navigate('/app/user/security/passkey-management');
  };

  useEffect(() => {
    getPasskeyList().then((resp) => {
      if (resp?.result?.items) {
        setHasBindPasskey(resp.result.items.length > 0);
      }
    });
  }, []);

  return (
    <AccountBasicItem
      icon="passkey"
      molyIcon={<PasskeyIcon />}
      text={$t('passkeys')}
      subText={$t('passkeyDesc')}
      status={hasBindPasskey}
      statusNode={<>{hasBindPasskey ? $t('Set up Tip') : $t('Not Set')}</>}
      operation={
        <>
          <Button
            size="small"
            data-radius="small"
            variant={hasBindPasskey ? 'default' : 'primary'}
            onClick={handleClick}
          >
            {$t('Setting')}
          </Button>
        </>
      }
    />
  );
};
export default PassKey;
